export function AdminSharedLinks({ sharedLinks }) {
  const statusColor = (status) => {
    if (status === 'eingelöst') return 'bg-green-500/20 text-green-400';
    if (status === 'angesehen') return 'bg-blue-500/20 text-blue-400';
    return 'bg-yellow-500/20 text-yellow-400';
  };

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Geteilte Links ({sharedLinks.length})</h2>
      <p className="text-sm text-gray-400">Carma-Links, die per Instagram, WhatsApp oder als Link verschickt wurden.</p>

      <div className="bg-gray-800 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-700">
            <tr>
              <th className="text-left px-4 py-3">Absender</th>
              <th className="text-left px-4 py-3">Empfänger</th>
              <th className="text-left px-4 py-3">Nachricht</th>
              <th className="text-center px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Datum</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {sharedLinks.map((s) => (
              <tr key={s.id} className="hover:bg-gray-700/50">
                <td className="px-4 py-3">
                  <div>{s.senderName}</div>
                  <div className="text-xs text-gray-500">{s.senderEmail}</div>
                </td>
                <td className="px-4 py-3 text-gray-300">{s.recipientName}</td>
                <td className="px-4 py-3 text-gray-400 max-w-xs truncate">{s.message}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`px-2 py-1 rounded text-xs ${statusColor(s.status)}`}>
                    {s.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-400">
                  {new Date(s.createdAt).toLocaleDateString('de-DE')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {sharedLinks.length === 0 && (
          <div className="text-gray-400 p-4">Noch keine geteilten Links</div>
        )}
      </div>
    </div>
  );
}
